module.exports = __webpack_public_path__ + "static/media/step4.cf389a31.png";